import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './en'
import fr from './fr'

export const defaultNS = 'translation'

export const resources = {
	en,
	fr,
} as const

export type AppLanguages = keyof typeof resources
export type AppNamespaces = keyof (typeof resources)['en']

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		defaultNS,
		supportedLngs: Object.keys(resources),
		fallbackLng: 'en',
		debug: true,

		detection: {
			order: ['localStorage', 'navigator'],
			lookupLocalStorage: 'i18nextLng',
		},
	})

i18n.changeLanguage()

export default i18n
